import { actionConst } from '../../constants/new-document.constants';
import { authHeader, authUploadHeader } from '../../../../helpers/auth-header';
import { client } from '../../../../actions';
import { documentsActions } from './documents.actions';
import {
  docTypes,
  documentsConstants,
} from '../../constants/documents.constants';
import { fromDateStr } from '../../../../helpers/utcDate';

export const actions = {
  openNewDocumentModal,
  closeNewDocumentModal,
  fetchDocumentTypeList,
  fetchOrdTypeList,
  fetchOssTypeList,
  fetchContractTypeList,
  fetchExecuterList,
  fetchResponsibleWorkersList,
  postDocument,
  deleteDocument,
  downloadDocument,
  resetPostedDocument,
  fetchAddrStreetList,
  fetchAddrBuildingList,
  applyAddrStreet,
  applyAddrBuilding,
  setAddrBuildingValue,
  setAddrFlatValue,
  fetchServiceCompaniesList,
  fetchDocumentVisibilityList,
  setVisibleDocumentDrawer,
  openEditDocument,
  openCreateDocument,
  openCloseDocument,
  updateFormValues,
  setChosenDocumentsFilter,
  openCreateDocumentByRelated,
};

function fetchAddrStreetList() {
  let rurl = '/Request/streets';
  return (dispatch) => {
    dispatch({
      type: actionConst.FETCH_ADDR_STREET_REF,
      payload: client.get(rurl, { headers: authHeader() }),
    });
  };
}

function fetchAddrBuildingList(street) {
  return street
    ? (dispatch) => {
        let rurl = '/Request/houses';
        if (street && !isNaN(street)) rurl += '/' + street;
        dispatch({
          type: actionConst.FETCH_ADDR_BUILDING_REF,
          payload: client.get(rurl, { headers: authHeader() }),
        });
      }
    : (dispatch) => {
        dispatch({
          type: actionConst.FETCH_ADDR_BUILDING_REF,
          payload: new Promise((resolve, reject) => {
            resolve({ data: [] });
          }),
        });
      };
}

function applyAddrStreet(value) {
  return (dispatch) => {
    dispatch({
      type: actionConst.APPLY_ADDR_STREET,
      payload: value,
    });

    dispatch(fetchAddrBuildingList(value));
    dispatch(fetchAddrFlatList(undefined));

    dispatch(setAddrBuildingValue(undefined));
    dispatch(setAddrFlatValue(undefined));
  };
}

function applyAddrBuilding(value, serviceId) {
  return (dispatch, getState) => {
    dispatch(fetchAddrFlatList(value));

    dispatch(setAddrBuildingValue(value));
    dispatch(setAddrFlatValue(undefined));
  };
}

function setAddrBuildingValue(value) {
  return (dispatch) => {
    dispatch({
      type: actionConst.SET_ADDR_BUILDING_VALUE,
      payload: value,
    });
  };
}

function setAddrFlatValue(value) {
  return (dispatch) => {
    dispatch({
      type: actionConst.SET_ADDR_FLAT_VALUE,
      payload: value,
    });
  };
}

function fetchAddrFlatList(building) {
  let rurl = '/Request/house_flats';
  if (building && !isNaN(building)) rurl += '/' + building;

  return (dispatch) => {
    dispatch({
      type: actionConst.FETCH_ADDR_FLAT_REF,
      payload: building
        ? client.get(rurl, { headers: authHeader() })
        : new Promise((resolve, reject) => {
            resolve({ data: [] });
          }),
    });
  };
}

function resetPostedDocument() {
  return (dispatch) => {
    dispatch({
      type: actionConst.RESET_POSTED_DOCUMENT,
    });
  };
}

function downloadDocument(value, attachName) {
  return (dispatch) => {
    const rurl = '/warranty/docs/file/' + value;

    client.get(rurl, { headers: authHeader() }).then((response) => {
      let data = Buffer.from(response.data, 'base64');
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', attachName);
      document.body.appendChild(link);
      link.click();

      /* dispatch({
				type: attachmentsConstants.FETCH_ATTACHMENT,
				payload: client.get(rurl, { headers: authHeader() }),
				attachName: attachName
			})*/
    });
  };
}

function deleteDocument(doc) {
  return (dispatch) => {
    let rurl = '/warranty/docs/' + doc.id;

    client
      .delete(rurl, { headers: authHeader() })
      .then(function (response) {
        dispatch({
          type: actionConst.DELETE_DOCUMENT,
          payload: doc.requestId,
        });
      })
      .catch(function (error) {
        console.log(error);
        dispatch({
          type: 'requestsConstants.POST_ERROR',
          payload: error,
        });
      });
  };
}

function postAttachments(nr, attach) {
  let rurl = '/docs/attach_file/' + nr;
  return (dispatch) => {
    client
      .post(rurl, attach, { headers: authUploadHeader() })
      .then((response) => {
        console.log(response);
      })
      .catch(function (error) {
        console.log(error);
        dispatch({
          //type: requestsConstants.POST_ERROR,
          payload: error,
        });
      });
  };
}

function postDocument(value) {
  const rurl = '/Docs';
  const attachments = value.files;
  const orgs =
    (value.typeId < 3 || value.typeId === 4) &&
    value.subTypeId !== 7 &&
    value.contractorType != 'fio_data'
      ? []
      : undefined;
  if (orgs) {
    console.log(orgs);
    value.keys.forEach((e) => {
      if (e || e === 0) {
        console.log(e);
        const o = {
          Id: null,
          OrgId: value.orgId && value.orgId[e] && parseInt(value.orgId[e]),
        };
        console.log(o);
        orgs.push(o);
      }
    });
  }

  const data = {
    Id: 0,
    TypeId: parseInt(value.typeId),
    Topic: value.Topic,
    DocNumber: value.DocNumber,
    DocDate: value.DocMoment && fromDateStr(value.DocMoment),
    OrgId: value.orgId && value.orgId[0] && parseInt(value.orgId[0]),
    Orgs: orgs,
    AppointedWorkers:
      value.executerIds &&
      value.executerIds
        .map((appointedWorker) => parseInt(appointedWorker))
        .filter(Boolean),
    OrganizationalTypeId: value.ordTypeId && parseInt(value.ordTypeId),
    AddressIds:
      value.addressIds &&
      value.addressIds.filter(Boolean).map((addressId) => parseInt(addressId)),
    ClientName: value.custNames && value.custNames?.filter(Boolean),
    ResponsibleWorkerId: parseInt(value.ResponsibleWorkerId),
    Description: value.Description,
    DoneDate: fromDateStr(value.DocDoneDate),
    ServiceCompanyId: parseInt(value.serviceCompanyId),
    DocumentVisibility: parseInt(value.documentVisibility),
  };

  return (dispatch) => {
    client
      .post(rurl, data, { headers: authHeader() })
      .then(function (response) {
        const nr = response.data;
        if (attachments.length > 0) {
          new Promise((resolve, reject) => {
            attachments.forEach((file) => {
              const formData = new FormData();
              formData.append('file', file);
              dispatch(postAttachments(nr, formData));
            });
            resolve();
          }).then(() => {
            dispatch(documentsActions.fetchDocuments());
          });
        }

        dispatch({
          type: actionConst.POST_DOCUMENT,
          payload: nr,
        });

        dispatch(documentsActions.fetchDocuments());
      })
      .catch(function (error) {
        console.log(error);
        dispatch({
          type: documentsConstants.POST_ERROR,
          payload: error,
        });
      });
  };
}

function fetchDocumentTypeList() {
  let rurl = '/docs/types';
  return (dispatch) => {
    dispatch({
      type: actionConst.FETCH_DOCTYPE_REF,
      payload: client.get(rurl, { headers: authHeader() }),
    });
  };
}

function fetchOrdTypeList() {
  let rurl = '/docs/ord_types';
  return (dispatch) => {
    dispatch({
      type: actionConst.FETCH_ORDTYPE_REF,
      payload: client.get(rurl, { headers: authHeader() }),
    });
  };
}

function fetchOssTypeList() {
  const rurl = `/docs/subtypes/${docTypes.meeting}`;
  return (dispatch) => {
    dispatch({
      type: actionConst.FETCH_OSS_TYPE_REF,
      payload: client.get(rurl, { headers: authHeader() }),
    });
  };
}

function fetchContractTypeList() {
  const rurl = `/docs/subtypes/${docTypes.contract}`;
  return (dispatch) => {
    dispatch({
      type: actionConst.FETCH_CONTRACT_TYPE_REF,
      payload: client.get(rurl, { headers: authHeader() }),
    });
  };
}

function fetchExecuterList() {
  let rurl = '/docs/workers';
  return (dispatch) => {
    dispatch({
      type: actionConst.FETCH_EXECUTER_REF,
      payload: client.get(rurl, { headers: authHeader() }),
    });
  };
}

function fetchResponsibleWorkersList() {
  const url = '/Docs/responsible_workers';
  return async (dispatch) => {
    const response = await client.get(url, { headers: authHeader() });
    dispatch({
      type: actionConst.FETCH_RESPONSIBLE_WORKERS,
      payload: response.data,
    });
  };
}

function setVisibleDocumentDrawer(value) {
  return (dispatch) => {
    dispatch({
      type: actionConst.VISIBLE_DOCUMENT_DRAWER,
      payload: value,
    });
  };
}

function openNewDocumentModal() {
  return (dispatch) => {
    dispatch({
      type: actionConst.OPEN_NEW_DOCUMENT_MODAL,
      //payload: request,
      //contractorId: res.data.orgId || null
    });
  };
}

function closeNewDocumentModal() {
  return (dispatch) => {
    dispatch({
      type: actionConst.CLOSE_NEW_DOCUMENT_MODAL,
    });
  };
}

function fetchServiceCompaniesList() {
  const url = '/Request/companies';
  return (dispatch) => {
    dispatch({
      type: actionConst.FETCH_SERVICE_COMPANIES_LIST,
      payload: client.get(url, { headers: authHeader() }),
    });
  };
}

function fetchDocumentVisibilityList() {
  const url = '/Docs/visibility';
  return (dispatch) => {
    dispatch({
      type: actionConst.FETCH_DOCUMENT_VISIBILITY_LIST,
      payload: client.get(url, { headers: authHeader() }),
    });
  };
}

function openEditDocument(payload) {
  return (dispatch) => {
    dispatch({
      type: actionConst.OPEN_EDIT_DOCUMENT,
      payload,
    });
  };
}

function openCreateDocument() {
  return (dispatch) => {
    dispatch({
      type: actionConst.OPEN_CREATE_DOCUMENT,
    });
  };
}

function openCreateDocumentByRelated(value) {
  return (dispatch) => {
    dispatch({
      type: actionConst.OPEN_DOCUMENT_CREATE_BY_RELATED,
      payload: value,
    });
  };
}

function openCloseDocument() {
  return (dispatch) => {
    dispatch({
      type: actionConst.CLOSE_DOCUMENT_DRAWER,
    });
  };
}

function updateFormValues(formValues) {
  return (dispatch) => {
    dispatch({
      type: actionConst.UPDATE_FORM_VALUES,
      payload: formValues,
    });
  };
}

function setChosenDocumentsFilter(value) {
  return (dispatch) => {
    dispatch({
      type: actionConst.SET_DOCUMENTS_CHOSEN_FILTER,
      payload: value,
    });
  };
}
